<template>
    <div class="order-wrapper" @touchmove="onMouseout">
        <template v-if="$route.query.headShow === '1'">
            <ctl-header title="我的订单" :onBack="goBack"></ctl-header>
        </template>
        <van-sticky  :offset-top="$route.query.headShow === '1'? 55:0">
        <van-tabs v-model="active"
                  animated
                  background="#FAFAFA"
                  color="#53CB85"
                  style="background: #FAFAFA"
                  title-active-color="#53CB85"
        >
            <van-tab title="全部">
            </van-tab>
            <van-tab title="待付款">
            </van-tab>
            <van-tab title="待发货">
            </van-tab>
        </van-tabs>
        </van-sticky>
        <orderCard :active="active"></orderCard>
    </div>
</template>
<script>
import { Tab, Tabs, Sticky } from 'vant'
import orderCard from './components/orderCard'

export default {
    name: 'order',
    components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [Sticky.name]: Sticky,
        orderCard: orderCard
    },
    data () {
        return {
            active: '',
            source: '',
            headShow: ''
        }
    },
    created () {
        // 暴露支付回调方法
        this.$jsBridge.registerHandler('payCallback', this.payCallback)
        // 设置基础数据
        let { headShow, source } = this.$route.query
        this.headShow = headShow
        this.source = source
    },

    methods: {
        // 支付回调
        payCallback (v) {
            this.$router.push({ name: 'payResult', query: { result: v, headShow: this.headShow, source: this.source } })
        },
        // 下拉bug
        onMouseout (e) {
            if (e.targetTouches[0].pageY >
                (document.querySelectorAll('.order-wrapper')[0].offsetHeight - document.querySelectorAll('.van-sticky')[0].offsetHeight)
            ) {
                document.querySelectorAll('.van-pull-refresh__track')[this.active].style.transform = 'translate3d(0px, 0px, 0px)'
            }
        },
        // 返回
        goBack () {
            this.$jsBridge.callBackHandler('returnLastPage')
        }
    }
}
</script>
<style lang="scss" scoped>
/deep/ {
    .van-tab--active .van-tab__text--ellipsis {
        font-size: 15px;
    }
    .van-tab__text--ellipsis {
        font-size: 13px;
    }
}

.order-wrapper {
    background-color: #FAFAFA;
    height: 100%;
}

</style>
